module.exports = __webpack_public_path__ + "static/media/esports-page-hero.c64db386.jpg";